// Build the store with the EXPIRE plugin active. The base `store` package silently ignores the
// 3rd "expiration" arg to store.set(), so tokens never expired (a security gap). Composing the
// engine with the expire plugin makes store.set(key, val, expiresAtMs) enforce TTL, and store.get
// returns undefined once expired — so a stale ACCESS_TOKEN auto-clears.
import storeEngine from "store/src/store-engine";
import localStorageBackend from "store/storages/localStorage";
import expirePlugin from "store/plugins/expire";
import storKey from "../constants/storageType";

const store = storeEngine.createStore([localStorageBackend], [expirePlugin]);

const LocalStorage = {
    // Checked if user logged in or not. The expire plugin auto-clears the token at TTL; we ALSO
    // decode the JWT `exp` claim as a belt-and-suspenders guard (covers tokens persisted before the
    // plugin was active, and clock-skew between the stored TTL and the real JWT expiry).
    isLoggedIn: function () {
        const accessToken = store.get(storKey.ACCESS_TOKEN);
        if (!accessToken || !accessToken.length) return false;
        try {
            const payload = JSON.parse(atob(accessToken.split('.')[1]));
            if (payload.exp && payload.exp * 1000 < Date.now()) {
                LocalStorage.logout();
                return false;
            }
        } catch (e) { /* not a decodable JWT — fall back to presence check */ }
        return true;
    },
    /**
     * User logged in continue
     * @param {*} access_token : login token
     * @param {*} expires_in_minutes : token expire time in minutes
     * @param {*} identity : user data to store
     */
    persistLogin: function (access_token, expires_in_minutes, identity) {
        const convertToMilliseconds = expires_in_minutes * 60 * 1000;
        const expiration = new Date().getTime() + convertToMilliseconds;

        store.set(storKey.AUTH_USER, identity);
        store.set(storKey.USER_ROLE_ID, identity.type_id);
        store.set(storKey.ACCESS_TOKEN, access_token, expiration);
    },
    /**
     * Logout: Remove all data from storage
     */
    logout: function () {
        store.remove(storKey.ACCESS_TOKEN);
        store.remove(storKey.AUTH_USER);
        store.remove(storKey.USER_ROLE_ID);
    },
    /**
     * Get access token form storage
     */
    getAccessToken: function () {
        return store.get(storKey.ACCESS_TOKEN);
    },
    /**
     * Get logged in user data
     */
    getAuthUser: function () {
        return store.get(storKey.AUTH_USER);
    },
    /**
     * Get user role id
     */
    getRoleId: function () {
        return store.get(storKey.USER_ROLE_ID);
    },
    /**
     * Set value by key paire into store
     */
    setValue: function (key, value) {
        store.set(key, value);
    },
    /**
     * Get value from store
     */
    getValue: function (key) {
        return store.get(key);
    },
    /**
     * Clear all store
     */
    cleanStore: function () {
        store.clearAll();
    }
}

export default LocalStorage;